import { get, isEmpty } from 'lodash';
import { notification } from 'antd';
import { qryDue4CB, qryDue, qryConfigParams } from '@pages/OnlinePayment/BillingInformation/services';
import { i18n } from 'fishx';
import { Base64 } from 'js-base64';
import { getRequestData } from '@/utils';

const initState = {
  billingInfo: {},
  configParams: {},
};

export default {
  namespace: 'billingInformation',
  state: {
    ...initState,
  },
  effects: {
    // 查询账单信息
    *qryDue4CB({ payload }, { call, put }) {
      const encryptParams = {
        url: '/whalecloud/cvbs/v1',
        belong: 'ocs',
        data: Base64.encode(JSON.stringify(payload)),
      };
      let result = payload.OtpKey ? yield call(qryDue4CB, encryptParams) : yield call(qryDue, encryptParams);
      result = getRequestData(result);
      if (Base64.isValid(result)) {
        result = JSON.parse(Base64.decode(result));
      }
      const billingInfo = result || {};
      if (!isEmpty(get(result, 'ApiResponse'))) {
        const resultCode = get(result, 'ApiResponse.resultCode');
        let description = get(result, 'ApiResponse.resultDesc');
        if (resultCode === 'BL-S-ACT-00731') {
          description = i18n('ONLINE_PAYMENT_PAYMENT_LINK_EXPIRED');
        }
        notification.error({
          message: 'Error',
          description,
        });
        return false;
      }
      yield put({
        type: 'save',
        payload: {
          billingInfo,
        },
      });
      return true;
    },

    *qryConfigParams({ payload }, { call, put }) {
      const response = yield call(qryConfigParams, payload);
      const paramsList = getRequestData(response);
      const paramsObj = {};
      if (!isEmpty(paramsList)) {
        paramsList.forEach(item => {
          if (item) {
            paramsObj[item.paramCode] = item.paramValue || item.defaultValue;
          }
        });
      }

      yield put({
        type: 'save',
        payload: { configParams: paramsObj },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
